import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostManualTreeChapterMove } from '../../../../../../api/manual-tree/manual-tree';
import { ErrorInfo } from '../../../../../../api/model';
import { useDefaultOptions } from '../../../../../../hooks/api';
import ErrorModal from '../../../../../modules/ErrorModal';
import SpinnerModal from '../../../../../modules/SpinnerModal';

type TreeProps = {
  chapterId: number | undefined;
  productionId: number | undefined;
};
function SectionChapterMenuMove({ chapterId, productionId }: TreeProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);

  // #region Up処理
  const {
    data: upData,
    mutateAsync: upMutateAsync,
    isSuccess: upIsSuccess,
    isLoading: upIsLoading,
    isError: upIsError,
    error: upError,
  } = usePostManualTreeChapterMove<AxiosError<ErrorInfo>, unknown>(options);
  const [displayUpError, setDisplayUpError] = useState(false);
  const upHandlePreview = async () => {
    await upMutateAsync({ chapterId: Number(chapterId), data: { direction: 0 } });
  };
  useEffect(() => {
    if (upIsSuccess) {
      if (productionId) {
        const basePath = process.env.REACT_APP_ROUTER_BASEPATH || '';
        window.location.href = `${basePath}/${language}/productions/sections/${productionId}/ps?section_id=${Number(
          upData.data.section_id
        )}`;
      }
    }
  }, [upIsSuccess, productionId, language, upData?.data.section_id]);
  useEffect(() => {
    setDisplayUpError(upIsError);
  }, [upIsError]);
  // #endregion

  // #region Down処理
  const {
    data: downData,
    mutateAsync: downMutateAsync,
    isSuccess: downIsSuccess,
    isLoading: downIsLoading,
    isError: downIsError,
    error: downError,
  } = usePostManualTreeChapterMove<AxiosError<ErrorInfo>, unknown>(options);
  const [displayDownError, setDisplayDownError] = useState(false);
  const downHandlePreview = async () => {
    await downMutateAsync({ chapterId: Number(chapterId), data: { direction: 1 } });
  };
  useEffect(() => {
    if (downIsSuccess) {
      if (productionId) {
        const basePath = process.env.REACT_APP_ROUTER_BASEPATH || '';
        window.location.href = `${basePath}/${language}/productions/sections/${productionId}/ps?section_id=${Number(
          downData.data.section_id
        )}`;
      }
    }
  }, [downIsSuccess, productionId, language, downData?.data.section_id]);

  useEffect(() => {
    setDisplayDownError(downIsError);
  }, [downIsError]);
  // #endregion

  return (
    <>
      <li
       
        onClick={async () => {
          await upHandlePreview();
        }}
      >
        <i className="fa-solid fa-arrow-circle-up" />
        {t('章移動')}
      </li>
      <li
        onClick={async () => {
          await downHandlePreview();
        }}
      >
        <i className="fa-solid fa-arrow-circle-down" />
        {t('章移動')}
      </li>
      {/* スピナーモーダル */}
      {downIsLoading && <SpinnerModal />}
      {upIsLoading && <SpinnerModal />}
      {/* 移動時のエラー */}
      {displayDownError && <ErrorModal error={downError} onClickOk={() => setDisplayDownError(false)} />}
      {displayUpError && <ErrorModal error={upError} onClickOk={() => setDisplayUpError(false)} />}
    </>
  );
}
export { SectionChapterMenuMove };
